<template>
  <div class="bg-white rounded-sm m-2">
    <b-row>
      <b-modal id="modal-details" size="xl" hide-footer ref="escalate-details" title="Escalated File">
        <b-col cols="12">
          <ReservationEscalationFile :reservation="reservation"
                                     :escalation-id="escalationId"
                                     :message="description" :time="escalateTime"
                                     :source="source"/>
        </b-col>
      </b-modal>
    </b-row>

    <b-row>
      <b-col cols="12" class="mx-3 mt-3">
        <b-row>
          <span class="title">Reservation Escalations</span>
        </b-row>
      </b-col>
    </b-row>

    <b-row class="mt-5">
      <b-col cols="12">
        <div class="mx-auto">
          <b-progress value="100" v-if="loading"  variant="#007ac5" height="0.2rem" animated></b-progress>
        </div>
        <b-row>
          <b-col cols="12">
            <table class="min-w-full leading-normal">
              <thead>
              <tr class="border-b border-t border-grey">
                <th class="t-header">Tracking No.</th>
                <th class="t-header">Name</th>
                <th class="t-header">Entity Type</th>
                <th class="t-header">Sub-Entity Type</th>
                <th class="t-header text-center">Submission Date</th>
                <th class="t-header text-center">Expiry Date</th>
                <th class="t-header text-center">Escalated By</th>
                <th class="t-header text-center">Action</th>
              </tr>
              </thead>

              <tbody>
              <tr :class="[(idx%2) ? rows.even : rows.odd]" v-for="(submission, idx) in escalations" :key="idx">
                <td class="t-body text-blue font-bold">
                  <span v-if="submission.reservation">{{submission.reservation.no}}</span>
                </td>
                <td class="t-body font-bold">
                  <span v-if="submission.reservation">{{submission.reservation.nameOptions[0].name}} ({{submission.reservation.nameOptions.length}})</span>
                </td>
                <td class="t-body text-capitalize">
                  <span v-if="submission.reservation">{{submission.reservation.type}}</span>
                </td>
                <td class="t-body text-capitalize">
                  <span v-if="submission.reservation">{{cleanEntityType(submission.reservation.subType)}}</span>
                </td>
                <td class="t-body text-center">
                  {{dateTimeFormat(submission.createdAt)}}
                </td>
                <td class="t-body text-center">
                  <span v-if="submission.reservation">{{dateFormat(submission.reservation.expiresOn)}}</span>
                </td>
                <td class="t-body text-center">
                  <span class="text-blue text-xs">{{submission.fromUser.firstName}} {{submission.fromUser.lastName}}</span>
                </td>
                <td class="t-body">
                  <div class="flex">
                    <button @click="view(submission)" class="bg-blue px-2 py-1 rounded-sm text-white w-full">View</button>
                  </div>
                </td>
              </tr>
              <tr>
                <td v-if="escalations.length == 0" colspan="8" class="bg-inertgrey text-center py-1">
                  <span class="text-sm">No results found</span>
                </td>
              </tr>
              </tbody>
            </table>
          </b-col>
        </b-row>
        <b-row class="mx-1" v-if="pagination.totalPages > 1">
          <b-col cols="1">
            <button @click="previous" :class="(currentPage > 1) ? 'paginate-btn' :'inert-btn'">Previous</button>
          </b-col>
          <b-col cols="1">
            <b-row>
              <b-col cols="12">
                <p class="paginate-details text-center">
                  <b-badge class="bg-blue text-white">
                    {{currentPage}}/{{pagination.totalPages}}
                  </b-badge>
                </p>
              </b-col>
            </b-row>
          </b-col>
          <b-col cols="1" >
            <button @click="next" :class="(currentPage < pagination.totalPages) ? 'paginate-btn' :'inert-btn'">Next</button>
          </b-col>
          <b-col cols="6"></b-col>
          <b-col cols="1">
            <b-form-select v-model="limit" class="w-full text-xs form-select border-0 paginate-details" v-on:change="fetch">
              <b-select-option value="15">15</b-select-option>
              <b-select-option value="20">20</b-select-option>
              <b-select-option value="50">50</b-select-option>
              <b-select-option value="100">100</b-select-option>
            </b-form-select>
          </b-col>
          <b-col cols="2">
            <b-row>
              <b-col class="mx-auto">
                <p class="paginate-details text-center text-xs font-bold">
                  <span>{{((currentPage - 1) * limit) + 1}}</span> -
                  <span v-if="limit > escalations.length">{{pagination.totalElements}}</span>
                  <span v-else>{{currentPage * limit}}</span>
                  of {{pagination.totalElements}}
                </p>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex"
import moment from "moment";
import ReservationEscalationFile from "@/views/home/services/reservation/escalations/ReservationEscalationFile";

export default {
  name: "ReservationEscalations",
  components: {ReservationEscalationFile},
  data(){
    return{
      selectedId:null,
      margin:"2px",
      hasContent:false,
      extension:{},
      loading:true,
      message:null,
      currentPage:1,
      limit:15,
      reservation:null,
      description:null,
      source:{},
      escalateTime:null,
      escalationId:null,
      form:{
        extensionId:null,
        status:null
      },
      escalations:[],
      pagination:{
        totalElements: 0,
        totalPages:0
      },
      rows:{
        odd:"border-t border-grey hover:bg-header_grey",
        even:"border-t border-grey bg-header_grey"
      },
    }
  },
  mounted() {
    this.fetch()
  },
  methods:{
    ...mapActions(["fetchReservationEscalations", "fetchAnalysisReport", "emptyAnalysisReport"]),
    cleanEntityType(name){
      let n = name.replaceAll("-", " ")
      return n.charAt(0).toUpperCase() + n.slice(1)
    },
    fetch(){
      let data = {
        status:"Pending",
        page:this.currentPage,
        limit:this.limit,
      }
      this.loading = true
      this.fetchReservationEscalations(data)
    },
    next(){
      if(this.currentPage < this.pagination.totalPages){
        this.currentPage++
        this.fetch()
      }
    },
    previous(){
      if(this.currentPage > 1){
        this.currentPage--
        this.fetch()
      }else{
        this.warningToast("Observation", "No more data to show")
      }
    },
    view(submission){
      this.form.reservationId = submission.id
      this.reservation = submission.reservation
      this.description = submission.description
      this.escalateTime = submission.createdAt
      this.escalationId = submission.escalationId
      this.source = submission.fromUser

      let data = submission.reservation
      if(data != null){
        let size = data.nameOptions.length
        let names = []
        this.hasContent = true
        this.form.reservationId = data.id
        this.emptyAnalysisReport()
        for (let i = 0; i < size; i++){
          names.push(data.nameOptions[i].name.trim())
        }
        this.fetchAnalysisReport(names)
        if(size == 1){
          this.selectedId = data.nameOptions[0].id
        }
      }
      this.$refs["escalate-details"].show()
    },
    onApprove(){
      this.loading = true
      this.form.status = "Approved"
      this.extendReservation(this.form)
      this.$refs["escalate-details"].hide()
    },
    checkForUpdates(){
      this.loading = true
      window.location.reload()
    },
    clearForm(){
      this.form = {
        description:null,
        reservationId:null,
        status:null
      }
    },
    dateFormat(date){
      if(date){
        return moment(date).format("DD-MM-YYYY")
      }
      return ""
    }
  },
  computed:{
    ...mapGetters([ "getReservationEscalations", "getReservationAssignmentSuccess", "getReservationEscalationError"]),
  },
  watch:{
    getReservationEscalations(data){
      this.loading = false
      this.escalations = data.content
      this.pagination = {
        totalPages:data.totalPages,
        totalElements:data.totalElements
      }
    },
    getReservationAssignmentSuccess(){
      this.$refs["escalate-details"].hide()
      this.fetch()
    },
  }
}
</script>

<style scoped>
@import "../../../../../assets/styles/table.css";

.icon{
  width: 170px;
}

.view-btn{
  @apply px-3 py-1 bg-white border-2 font-bold border-blue text-blue text-xs w-full;
}

.view-btn:hover{
  @apply bg-blue text-white;
}

.approve-btn{
  @apply px-3 py-1 bg-white border-2 font-bold border-green text-green text-xs w-full;
}

.approve-btn:hover{
  @apply bg-green text-white;
}

.reject-btn{
  @apply px-3 py-1 bg-white border-2 border-red text-red font-bold text-xs w-full;
}

.reject-btn:hover{
  @apply bg-red text-white;
}

.paginate-details{
  @apply px-3 py-2 bg-white my-2 text-sm text-gray;
}

.paginate-btn{
  @apply px-3 py-2 bg-white border border-white my-2 text-sm text-blue w-full;
}

.paginate-btn:hover{
  @apply border border-blue text-blue rounded-sm;
}

.inert-btn{
  @apply px-3 py-2 bg-white my-2 text-sm text-grey w-full;
}
</style>